export class FormatConverter {

  constructor (formatMapping) {
    this.formatMapping = formatMapping;
    this.formatCache = {};
  }

  convert (javaFormat) {
    if (!this.formatCache[javaFormat]) {
      this.formatCache[javaFormat] = this.doConvert(javaFormat);
    }

    return this.formatCache[javaFormat];
  }

  doConvert (javaFormat) {
    let i = 0;
    let beginIndex = -1;
    let lastChar = null;
    let result = '';

    for (; i < javaFormat.length; i++) {
      const char = javaFormat.charAt(i);

      if (lastChar !== char) {
        result = this.appendMappedToken(javaFormat, beginIndex, i, result);
        beginIndex = i;
      }

      lastChar = char;
    }

    return this.appendMappedToken(javaFormat, beginIndex, i, result);
  }

  appendMappedToken (formatString, beginIndex, currentIndex, result) {
    if (beginIndex !== -1) {
      const token = formatString.substring(beginIndex, currentIndex);
      return result + (this.formatMapping[token] || token);
    }
    return result;
  }

}
